module.exports = __webpack_public_path__ + "img/rmmyd-td.adf26a61.png";